module.exports = __webpack_public_path__ + "img/logoo.90de2120.png";